import {
  invalidateAuthStorageCache,
  setClientProfileId,
  setRecruiterCompanyId,
} from '@/config/axios';
import { IS_ADMIN_KEY } from '@/constants/roles';

type AccessTokenTypesTuple = ['Bearer', 'Token'];
type AccessTokenType = AccessTokenTypesTuple[number];

const ACCESS_TOKEN_KEY = 'access_token';
const ACCESS_TOKEN_TYPE_KEY = 'access_token_type';
export const ADMIN_TOKEN_KEY = 'admin_token';
const DEFAULT_ACCESS_TOKEN_TYPE: AccessTokenType = 'Token';

export const storeAccessToken = (
  token: string,
  tokenType: AccessTokenType = DEFAULT_ACCESS_TOKEN_TYPE,
) => {
  localStorage.setItem(ACCESS_TOKEN_KEY, token);
  localStorage.setItem(ACCESS_TOKEN_TYPE_KEY, tokenType);
  invalidateAuthStorageCache(['access_token', 'access_token_type']);
};

export const storeAdminToken = (token: string) => {
  localStorage.setItem(ADMIN_TOKEN_KEY, token);
};

export const removeLocalStorageItem = (key: string) => {
  localStorage.removeItem(key);
  if (
    key === ACCESS_TOKEN_KEY ||
    key === ACCESS_TOKEN_TYPE_KEY ||
    key === ADMIN_TOKEN_KEY ||
    key === IS_ADMIN_KEY ||
    key === 'admin_user_id' ||
    key === 'client_profile_id' ||
    key === 'recruiter_company_id'
  ) {
    invalidateAuthStorageCache([key]);
  }
};

export const getLocalStorageItem = (key: string) => {
  return localStorage.getItem(key);
};

export const getAccessToken = () => getLocalStorageItem(ACCESS_TOKEN_KEY);

export const getAccessTokenType = () =>
  getLocalStorageItem(ACCESS_TOKEN_TYPE_KEY) || DEFAULT_ACCESS_TOKEN_TYPE;

export const storeAdminMarker = () => {
  localStorage.setItem(IS_ADMIN_KEY, 'true');
  invalidateAuthStorageCache([IS_ADMIN_KEY]);
};

export const storeAdminUserId = (adminUserId: string) => {
  localStorage.setItem('admin_user_id', adminUserId);
  invalidateAuthStorageCache(['admin_user_id']);
};

export const removeAdminUserId = () => {
  localStorage.removeItem('admin_user_id');
  invalidateAuthStorageCache(['admin_user_id']);
};

/** Wipe tokens, impersonation markers, and workspace/profile headers. */
export const clearAuthSessionStorage = () => {
  removeLocalStorageItem(ACCESS_TOKEN_KEY);
  removeLocalStorageItem(ACCESS_TOKEN_TYPE_KEY);
  removeLocalStorageItem(IS_ADMIN_KEY);
  removeLocalStorageItem(ADMIN_TOKEN_KEY);
  removeAdminUserId();
  setClientProfileId(null);
  setRecruiterCompanyId(null);
};

export const storePathname = (pathname: string) => {
  localStorage.setItem('pathname', pathname);
};

export const storeJobId = (jobId: string) => {
  localStorage.setItem('job', jobId);
};

export const storeSearch = (search: string) => {
  localStorage.setItem('search', search);
};
